module.exports = __webpack_public_path__ + "img/search.9aeff54b.svg";